import React, { useState, useMemo, useEffect } from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Provider } from 'react-redux'

import './config'

import ThemeProvider from './components/Theme'
import LiteralsProvider from './components/Literals'
import Router from './Router'

import LandingPageMarketing from './components/LandingMarketing'
import AgeGate from './components/AgeGate'
import AppContainer from './containers/App'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './store'
import { parseParams, getDomain, inIframe } from './utils'
import track from './track'
import Cookie from './cookie'
import './app.css'

const lastMinuteOfYear9999 = new Date(Date.UTC(9999, 11, 31, 23, 59))

function initConfigs(standalone, domain) {
  if (
    standalone &&
    standalone.domain &&
    window.appData.id !== standalone.domain //rever
  ) {
    window.changeAppData(standalone.domain, process.env.PRODUCT_FINDER_ENV)
  }
  const params = parseParams()
  const store = configureStore({ config: params })

  if (params.sessionMode && params.sessionMode === 'anonimo') {
    Cookie.set('session-mode', params.sessionMode, getDomain(), lastMinuteOfYear9999.toUTCString())
  }

  registerServiceWorker(store)

  return [store, params]
}

const App = (standalone, domain) => {
  const urlDomain = window.location.toString()
  const [store, params] = useMemo(() => initConfigs(standalone, domain), [])
  const [showAgeGate, setShowAgeGate] = useState(params.ageGate && !inIframe())

  useEffect(() => {
    track('APP_PAGEVIEW', { name: params.brandName })

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href =
      'https://fonts.googleapis.com/css2?family=Alegreya:wght@400;500;700&family=PT+Sans:wght@400;700&family=Roboto:wght@300;400;500;700&display=swap&family=Roboto+Condensed:wght@300;400;700&family=STIX+Two+Text:wght@400;500;700&display=swap'

    document.head.appendChild(link)
  }, [params])

  useEffect(() => {
    const regexUrl = /^(?!.*custom\.pertinhodemim).*\b(?:pertinhodemim\.com|pertinhodemim\.app|aquiperto\.app)\b.*$/g

    if (regexUrl.test(urlDomain)) return

    const gtagId =
      window.location.href.indexOf('ondetem.app') !== -1 ? 'UA-69739739-16' : 'UA-69739739-10'

    params.isGTM = params?.gtag?.match(/^GTM-/g)

    const loadScript = () => {
      const script = document.createElement('script')
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`
      script.async = true
      document.head.appendChild(script)

      script.onload = () => {
        window.dataLayer = window.dataLayer || []

        function gtag() {
          window.dataLayer.push(arguments)
        }

        window.gtag = gtag

        gtag('js', new Date())
        gtag('config', gtagId)
        gtag('config', 'G-5C041PHYG1')
        if (!params.isGTM) gtag('config', params.gtag)

        if (localStorage.getItem('gofind-user-allow-cookies') === null) {
          gtag('consent', 'default', {
            analytics_storage: 'granted'
          })
        } else {
          gtag('consent', 'default', JSON.parse(localStorage.getItem('gofind-user-allow-cookies')))
        }
      }
    }

    loadScript()
  }, [])

  if (
    (urlDomain.includes('www.pertinhodemim') || urlDomain.includes('www.aquiperto')) &&
    !urlDomain.includes('/loja')
  ) {
    return (
      <LiteralsProvider language={params.language}>
        <LandingPageMarketing />
      </LiteralsProvider>
    )
  }

  return (
    <>
      <Provider store={store}>
        <LiteralsProvider language={params.language}>
          <ThemeProvider config={params}>
            <CssBaseline />
            {showAgeGate ? (
              <AgeGate
                imageUrl={params.imageUrl}
                ageGateRedirect={params.ageGateRedirect}
                ageGateMessage={params.ageGateMessage}
                setShowAgeGate={setShowAgeGate}
              />
            ) : (
              <Router config={params}>
                <AppContainer />
              </Router>
            )}
          </ThemeProvider>
        </LiteralsProvider>
      </Provider>
    </>
  )
}

export default App
